
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="name" label="学校名称"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column prop="phone" label="电话"> </el-table-column>

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button> -->
          <el-button size="mini" @click="addSchoolMan(scope.row)"
            >查看校管</el-button
          >
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="添加校管" :visible.sync="addmanVis" width="40%">
      <el-form
        label-position="right"
        :model="addUserFrom"
        :rules="addUserFromRule"
        label-width="80px"
        ref="addManref"
      >
        <el-form-item label="姓名:">
          <el-input v-model="addUserFrom.name"></el-input>
        </el-form-item>
        <el-form-item label="账号:" prop="account">
          <el-input v-model="addUserFrom.account"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password">
          <el-input v-model="addUserFrom.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addmanVis = false">取 消</el-button>
        <el-button type="primary" @click="addMandata">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="校管详情" :visible.sync="addUserVis" width="50%">
      <el-button type="primary" @click="addmanVis = true" size="small"
        >+添加校管</el-button
      >
      <el-table :data="xiaoguanList" style="width: 100%">
        <el-table-column prop="account" label="账号"> </el-table-column>
        <el-table-column prop="name" label="姓名"> </el-table-column>
        <el-table-column label="编辑">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="delxiaoguan(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%">
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="学校名称" prop="name">
          <el-input
            size="small"
            v-model="editForm.name"
            auto-complete="off"
            placeholder="请输入学校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input
            size="small"
            v-model="editForm.address"
            auto-complete="off"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input
            size="small"
            v-model="editForm.phone"
            auto-complete="off"
            placeholder="请输入电话"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  schoollist,
  schoocreate,
  schooldelete,
  schooledit,
  accountcreate,
  getsaist,
  accountdelete,
} from "@/api/userMG";
import Pagination from "@/components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏,
      addUserVis: false,
      addmanVis: false,
      title: "添加",
      editForm: {
        name: "",
        address: "",
        phone: "",
        id: "",
      },
      // rules表单验证
      rules: {
        name: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
      },
      addUserFrom: {
        account: "",
        password: "",
        schoolId: "",
        name: "",
      },
      addUserFromRule: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      addUserList: [],
      xiaoguanList: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },

  created() {
    this.getdata(this.formInline);
  },

  methods: {
    // 删除
    delxiaoguan(item) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          accountdelete(item.id)
            .then((res) => {
              this.$message({
                type: "success",
                message: "已删除!",
              });
              this.getxiaoGuan();
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //添加校管
    addMandata() {
      this.$refs.addManref.validate((validateres) => {
        if (validateres) {
          accountcreate(this.addUserFrom)
            .then((res) => {
              this.addmanVis = false;
              this.loading = false;
              this.$message({
                type: "success",
                message: "添加成功！",
              });
              this.getxiaoGuan();
            })
            .catch((err) => {
              this.addmanVis = false;
              this.loading = false;
              this.$message.error(err.response.data.msg);
            });
        }
      });
    },
    // 获取校管账号
    getxiaoGuan() {
      getsaist(this.addUserFrom.schoolId).then((res) => {
        this.xiaoguanList = res;
      });
    },
    // 添加校管
    addSchoolMan(item) {
      this.addUserFrom.schoolId = item.id;
      this.getxiaoGuan();
      this.addUserVis = true;
    },
    // 获取学校列表
    getdata() {
      schoollist().then((res) => {
        this.listData = [];
        this.listData = res;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (row) {
      this.editFormVisible = true;
      this.editForm.name = "";
      this.editForm.address = "";
      this.editForm.phone = "";
      this.editForm.id = "";
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.name = row.name;
        this.editForm.address = row.address;
        this.editForm.phone = row.phone;
        this.editForm.id = row.id;
      } else {
        this.title = "添加";
      }
    },
    //修改学校
    submitForm(editData) {
      console.log(this.editForm, 123);

      this.$refs[editData].validate((valid) => {
        if (valid) {
          if (!this.editForm.id) {
            Reflect.deleteProperty(this.editForm, "id");
            schoocreate(this.editForm)
              .then((res) => {
                console.log(res);
                this.editFormVisible = false;
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "添加成功！",
                });
                this.getdata();
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error(err.response.data.msg);
              });
          } else {
            schooledit(this.editForm)
              .then((res) => {
                console.log(res);
                this.editFormVisible = false;
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "修改成功！",
                });

                this.getdata();
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error(err.response.data.msg);
              });
          }
        } else {
          return false;
        }
      });
    },
    //删除校管
    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          schooldelete(row.id)
            .then((res) => {
              this.$message({
                type: "success",
                message: "已删除!",
              });
              this.getdata();
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/admin/school/schoollits.vue